import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core';
import { Facet } from '~model/facet';
import { FacetOption } from '~model/facet-option';
import { translate } from '~service/translation-service';

@Component({
  tag: 'uvex-product-list-active-facets',
})
export class ProductListActiveFacets {
  @Prop() resultCount: number = 0;
  @Prop() facets: Facet[] = [];

  @Event() facetChanged: EventEmitter<Facet>;
  @Event() facetResetAll: EventEmitter<void>;

  async removeFacet(facet: Facet, option: FacetOption) {
    option.selected = !option.selected;
    facet.used = facet.options.some(option => option.selected);
    this.facetChanged.emit(facet);
  }

  async removeAllFacets() {
    this.facetResetAll.emit();
  }

  renderActiveFacets() {
    const usedFacets = this.facets.filter(facet => facet.used);

    return usedFacets
      .filter(facet => ['list', 'icon', 'icon-text', 'slider'].indexOf(facet.type) !== -1)
      .reduce(
        (activeFacets: Element[], facet) => [
          ...activeFacets,
          ...facet.options
            .filter((option: FacetOption) => option.selected)
            .map((option: FacetOption) => (
              <a role="button" onClick={() => this.removeFacet(facet, option)}>
                <svg width="12" height="12">
                  <use href="#fa-close"></use>
                </svg>{' '}
                {option.label}
              </a>
            )),
        ],
        [],
      );
  }

  renderResetFacets() {
    if (!this.facets.some(facet => facet.used)) {
      return;
    }
    return (
      <a role="button" class="reset" onClick={() => this.removeAllFacets()}>
        <svg width="12" height="12">
          <use href="#fa-close"></use>
        </svg>{' '}
        {translate('sw.listing.filter.reset_all')}
      </a>
    );
  }

  render() {
    return (
      <Host class="product-list-active-facets">
        <a role="button" class="count">
          {translate('sw.listing.items_count', this.resultCount)}
        </a>

        {this.renderActiveFacets()}
        {this.renderResetFacets()}
      </Host>
    );
  }
}
